(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('system-administration', {
            parent: 'account',
            url: '/system-administration',
            data: {
                pageTitle: 'global.menu.settings.system-administration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/system-administration/system-administration.html',
                    controller: 'SystemAdministrationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('users');
                    $translatePartialLoader.addPart('system-administration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
